import type {CustomTypeOptions, InitOptions} from 'i18next';

import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import type {I18n} from './i18n';

import {initDayjs} from './dayjs/init.dayjs';

type Result = ReturnType<typeof i18next.init>;

export const init = async (
  options: InitOptions<CustomTypeOptions>,
): Promise<Result> => {
  const instance = i18next.use(LanguageDetector);

  if (process.env.NODE_ENV !== 'production') {
    const HMRPlugin = require('i18next-hmr/plugin').HMRPlugin;
    const HttpBackend = require('i18next-http-backend').default;

    const httpBackend = new HttpBackend(null, {
      loadPath: async (
        language: I18n.Language[],
        namespace: I18n.Namespace[],
      ) => {
        return `/locales/${language}/${namespace}.json`;
      },
    });

    instance.use(httpBackend).use(
      new HMRPlugin({
        webpack: {
          client: typeof window !== 'undefined',
          server: typeof window === 'undefined',
        },
      }),
    );
  } else {
    const resourcesToBackend = require('i18next-resources-to-backend').default;

    instance.use(
      resourcesToBackend(
        async (language: I18n.Language, namespace: I18n.Namespace) => {
          if (language === 'en') {
            return;
          }

          /* webpackChunkName: "locale-[request]" */
          return import(`../locales/${language}/${namespace}.json`);
        },
      ),
    );
  }

  const result = await instance.init({
    ...options,
    partialBundledLanguages: true,
  });

  await initDayjs(instance.language);

  return result;
};
